export const getDefaultValues = (notificationPopupData) => ({
  NotificationPopupTitlePanel: notificationPopupData?.NotificationPopupTitlePanel || '',
  NotificationPopupTitle: notificationPopupData?.NotificationPopupTitle || '',
  NotificationPopupBody: notificationPopupData?.NotificationPopupBody || '',
  NotificationPopupTitleButton: notificationPopupData?.NotificationPopupTitleButton || '',
  NotificationPopupLinkButton: notificationPopupData?.NotificationPopupLinkButton || '',
  NotificationPopupImageUrl: notificationPopupData?.NotificationPopupImageUrl || '',
  NotificationPopupImageLink: notificationPopupData?.NotificationPopupImageLink || '',
  NotificationPopupStartDate: notificationPopupData?.NotificationPopupStartDate || '',
  NotificationPopupEndDate: notificationPopupData?.NotificationPopupEndDate || '',
  NotificationPopupStartTime: notificationPopupData?.NotificationPopupStartTime || '',
  NotificationPopupEndTime: notificationPopupData?.NotificationPopupEndTime || '',
  NotificationPopupNumberPerDay: notificationPopupData?.NotificationPopupNumberPerDay || '',
  NotificationPopupMinuteWithDelay: notificationPopupData?.NotificationPopupMinuteWithDelay || '',
  NotificationPopupUrlPrefix: notificationPopupData?.NotificationPopupUrlPrefix || '',
  NotificationPopupStatus: notificationPopupData?.NotificationPopupStatus ? true : false,
  NotificationPopupLinkMp4: notificationPopupData?.NotificationPopupLinkMp4 || '',
  NotificationPopupUserLevel: notificationPopupData?.NotificationPopupUserLevel || 0,
  NotificationPopupWidth: notificationPopupData?.NotificationPopupWidth || 400,
  NotificationPopupHeight: notificationPopupData?.NotificationPopupHeight || 300,
});
